import { linea } from "../../shared/lineaVencimientos";

import "../../routes/css/lineaVencimientos.css";

/* La línea de tiempo de vencimientos de la ficha de unidad.
 *
 * Recibe los vencimientos ya resueltos —`{ clave, label, dias }`— y los dibuja
 * sobre un eje fijo de 60 días atrás a 180 adelante, con HOY marcado. El cálculo
 * (posición, estado, orden) vive en `shared/lineaVencimientos`; acá sólo se
 * pinta. Las etiquetas se alternan arriba/abajo para que no se pisen.
 *
 * Si no hay ningún vencimiento con fecha ni sin ella, no se dibuja nada: una
 * pista vacía se leería como que a la unidad no le vence nada, que no es lo
 * mismo que no tener el dato. */
export default function LineaVencimientos({ items }) {
  const { hitos, sinDato, hoyPct } = linea(items);
  if (!hitos.length && !sinDato.length) return null;

  return (
    <section className="lv" aria-label="Vencimientos">
      <div className="lv-cab">
        <h3>Vencimientos</h3>
        <span className="lv-rango">60 días atrás → 6 meses adelante</span>
      </div>

      <div className="lv-pista">
        <div className="lv-eje" />
        <div className="lv-hoy" style={{ left: `${hoyPct}%` }}>
          <span>HOY</span>
        </div>
        {hitos.map((h, i) => (
          <div
            key={h.clave}
            className={
              `lv-hito lv--${h.estado}` +
              (i % 2 ? " lv-hito--abajo" : "") +
              (h.fueraDeRango ? " fuera" : "")
            }
            style={{ left: `${h.pct}%` }}
            title={h.fueraDeRango ? `${h.label} · ${h.texto}` : undefined}
          >
            <div className="lv-etq">
              <b>{h.label}</b>
              <span>{h.texto}</span>
            </div>
            <span className="lv-punto" />
          </div>
        ))}
      </div>

      {sinDato.length > 0 && (
        <div className="lv-sindato">
          Sin dato: {sinDato.map((s) => s.label).join(" · ")}
        </div>
      )}
    </section>
  );
}
